var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c(_setup.CommonAside)],1),_c('el-container',[_c('el-header',[_c(_setup.CommonHeader)],1),_c('el-main',[_c('RouterView')],1),_c('el-footer',[_c(_setup.CommonFooter)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }